import React, { useState, useCallback } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'

type DailogPeops = {
    title?: string
    content?: string
    render?: () => JSX.Element
    displayBtnSave?: boolean
    displayBtnCancel?: boolean
    displayBtnClose?: boolean
    displayBtnYes?: boolean
    displayBtnNo?: boolean
    afterBtnSave?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    afterBtnCancel?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    afterBtnClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    customBtnSave?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    customBtnCancel?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    customBtnClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    afterBtnYes?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    afterBtnNo?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
    widthDialog?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    labelBtn?: string[]
}

export type CallBackOpenDialog = {
    openDialog?: (options: DailogPeops) => void
    closeDialog?: () => void
}

const defaultConfig: DailogPeops = {
    render: undefined,
    displayBtnSave: false,
    displayBtnCancel: false,
    displayBtnClose: false,
    displayBtnYes: false,
    displayBtnNo: false,
    widthDialog: 'xs',
}

const withDialog = (WrapperComponent: any) => (props: any) => {
    const [open, setOpen] = useState(false)
    const [dialogConfig, setDialogConfig] = useState<DailogPeops>(defaultConfig)
    const { t } = useTranslation()
    const classes = useStyles()

    const handleOpen = (options: DailogPeops) => {
        setOpen(true)
        let data = {
            ...defaultConfig,
            ...options,
            render: options.render ? options.render : undefined,
        }
        // console.log('handleOpen', data)
        setDialogConfig(data)
    }

    const closeDialog = () => {
        setOpen(false)
    }

    const handleSave = useCallback(
        (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            if (dialogConfig?.customBtnSave) {
                dialogConfig.customBtnSave(e)
            } else if (dialogConfig.afterBtnSave) {
                dialogConfig.afterBtnSave(e)
                closeDialog()
            } else {
                closeDialog()
            }
        },
        [dialogConfig, closeDialog],
    )

    const handleCancel = useCallback(
        (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            if (dialogConfig?.customBtnCancel) {
                dialogConfig.customBtnCancel(e)
            } else if (dialogConfig?.afterBtnCancel) {
                dialogConfig.afterBtnCancel(e)
                closeDialog()
            } else {
                closeDialog()
            }
        },
        [dialogConfig, closeDialog],
    )

    // const handleClose = useCallback(
    //     (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    //         console.log('handleClose') //comment
    //         if (dialogConfig?.customBtnClose) {
    //             dialogConfig.customBtnClose(e)
    //         } else if (dialogConfig?.afterBtnClose) {
    //             dialogConfig.afterBtnClose(e)
    //             closeDialog()
    //         } else {
    //             console.log('closeDialog') //comment
    //             closeDialog()
    //         }
    //     },
    //     [dialogConfig, closeDialog],
    // )

    const handleClose = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
        console.log('handleClose') //comment
        if (dialogConfig?.customBtnClose) {
            dialogConfig.customBtnClose(e)
        } else if (dialogConfig?.afterBtnClose) {
            dialogConfig.afterBtnClose(e)
            closeDialog()
        } else {
            console.log('closeDialog') //comment
            closeDialog()
        }
    }

    const handleYes = useCallback(
        (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            if (dialogConfig.afterBtnYes) {
                dialogConfig.afterBtnYes(e)
                closeDialog()
            } else {
                closeDialog()
            }
        },
        [dialogConfig, closeDialog],
    )

    const handleNo = useCallback(
        (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
            if (dialogConfig.afterBtnNo) {
                dialogConfig.afterBtnNo(e)
                closeDialog()
            } else {
                closeDialog()
            }
        },
        [dialogConfig, closeDialog],
    )

    return (
        <React.Fragment>
            {dialogConfig && (
                <Dialog open={open} hideBackdrop={false} maxWidth={dialogConfig?.widthDialog} fullWidth>
                    <DialogTitle id="alert-dialog-title" sx={{ bgcolor: '#F8F9FD', color: '#2C64A3' }}>
                        <Typography sx={{ fontWeight: 400, fontSize: '18px' }}>{dialogConfig.title}</Typography>
                    </DialogTitle>
                    <DialogContent sx={{ p: 0 }}>
                        {dialogConfig.render ? (
                            dialogConfig.render()
                        ) : (
                            <DialogContentText
                                id="alert-dialog-description"
                                sx={{ p: 3, color: '#000', fontSize: '14px' }}
                            >
                                {dialogConfig?.content}
                            </DialogContentText>
                        )}
                    </DialogContent>
                    {dialogConfig.displayBtnClose && (
                        <DialogActions
                            sx={{ justifyContent: 'center', pt: dialogConfig.render ? 3 : 0, pr: 3, pb: 3, pl: 3 }}
                        >
                            <Button
                                variant="outlined"
                                onClick={handleClose}
                                sx={{ width: '100%' }}
                                className={classes.btn}
                            >
                                {t('BUTTON.CLOSE')}
                            </Button>
                        </DialogActions>
                    )}
                    {dialogConfig.displayBtnSave ||
                    dialogConfig.displayBtnCancel ||
                    dialogConfig.displayBtnNo ||
                    dialogConfig.displayBtnYes ? (
                        <DialogActions
                            sx={{ justifyContent: 'flex-end', pt: dialogConfig.render ? 3 : 0, pr: 3, pb: 3, pl: 3 }}
                        >
                            {dialogConfig.displayBtnCancel && (
                                <Button variant="outlined" onClick={handleCancel} className={classes.btn}>
                                    {t('BUTTON.CANCEL')}
                                </Button>
                            )}
                            {dialogConfig.displayBtnSave && (
                                <Button variant="contained" onClick={handleSave} className={classes.btn}>
                                    {t('BUTTON.SAVE')}
                                </Button>
                            )}
                            {dialogConfig.displayBtnNo && (
                                <Button variant="outlined" onClick={handleNo} className={classes.btn}>
                                    {dialogConfig.labelBtn ? dialogConfig.labelBtn[1] : t('BUTTON.NO')}
                                </Button>
                            )}
                            {dialogConfig.displayBtnYes && (
                                <Button variant="contained" onClick={handleYes} className={classes.btn}>
                                    {dialogConfig.labelBtn ? dialogConfig.labelBtn[0] : t('BUTTON.YES')}
                                </Button>
                            )}
                        </DialogActions>
                    ) : null}
                </Dialog>
            )}
            <WrapperComponent {...props} openDialog={handleOpen} closeDialog={closeDialog} />
        </React.Fragment>
    )
}

const useStyles = makeStyles((theme: Theme) => ({
    btn: {
        fontSize: '14px !important',
        fontWeight: 500,
    },
}))

export default withDialog
